import { render } from "./ImportEndpointsDialog.vue?vue&type=template&id=45c67130&scoped=true&ts=true"
import script from "./ImportEndpointsDialog.ts?vue&type=script&lang=ts"
export * from "./ImportEndpointsDialog.ts?vue&type=script&lang=ts"

import "./ImportEndpointsDialog.vue?vue&type=style&index=0&id=45c67130&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c67130"]])

export default __exports__